(function () {
    'use strict';

    realmCommerceApp.controller("CustomerResetPasswordController", CustomerResetPasswordController);

    /*ngInject@*/
    function CustomerResetPasswordController() {
        var vm = this;


        vm.resetPasswordModel = {}
        vm.resetPasswordFields = [
            {
                key: 'password',
                type: 'input',
                name: 'password',
                templateOptions: {
                    label: 'Enter your new password here',
                    type: 'password',
                    placeholder: 'New Password',
                    required: true
                }
            },
            {
                key: 'confirm_password',
                name: 'confirm_password',
                type: 'input',
                optionsTypes: ["matchField"],
                className: 'italicLabel',
                templateOptions: {
                    type: 'password',
                    placeholder: 'Confirm Password',
                    label: 'Choose a password that is at least six characters long.',
                    required: true
                },
                "data": {
                    "fieldToMatch": "password"
                }
            }
        ];
    }
})();




// WEBPACK FOOTER //
// ./static/js/app/customer/customer.resetpassword.js